import React from "react";
import { API_URL } from "../../constants/api";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import {
  apiRequest,
  apiPost,
  apiPut,
  spsApiPost,
  uploadSpsAPiRequest,
  getSpsAPiRequest,
  apiBatchRequest
} from "../../utils/api_service";
import {
  AppBar,
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Tooltip,
  Typography
} from "@material-ui/core";
import "./security.less";
import LabelWithSelect from "../common/selectWithLabel/selectWithLabel";
import { InputLabel } from "@material-ui/core";
import { ShowToast, toastType } from "../../utils/toast-service";
import { validateInput } from "../../utils/validations";
import { convertIntoDDFormat } from "../../utils/generic";
import uniqBy from "lodash/uniqBy";
import {
  GetUserName,
  IsSectionVisible,
  GetUserConfiguration,
  PaperComponent,
  getToolTipText,
  GetEnableProperty,
  GetPropertyVisibility
} from "../../utils/helper";
import FileAttachments from "../common/sharepoint-upload/file-attachments";
import { getSharepointUrl } from "../common/sharepoint-upload/sharepoint_api";
import { getSPSTokenData, setSPSToken } from "../../constants/constants";
import KeyBoardDateTimePickers from "../common/KeyboardDateTimePicker/DatePicker";
import moment from "moment";
import {
  INCIDENT_STATUS,
  SECTIONS,
  Operators,
  DCOP_SOURCE_SYSTEM,
  SHAREPOINT_SOURCE_SYSTEM,
  TOOLTIP_LABEL,
  EMAIL_LOG_HEADER,
  EMAIL_LOG_CONFIG
} from "../../constants/appConstants";
import InputLabelWithToolTip from "../common/InputLabelToolTip/InputLabelWithToolTip";
import TextFieldWithToolTip from "../common/TextFieldWithToolTip/TextFieldWithToolTip";
import commonLabels from "../../constants/messageConstants";
import PrintIcon from "@material-ui/icons/Print";
import { IoMdCloseCircleOutline } from "react-icons/io";
import { printForm } from "../../utils/downloading";
import { PRINT_SECURITY_FORM } from "../../constants/ssrs_api";
import DraftsIcon from "@material-ui/icons/Drafts";
import DialogModal from "../common/DialogModal/Dialog";
import { getFormattedValues } from "../../utils/formatData";
let uploadFileList = [];

const securityEventNotification = [
  {
    name: "Event Type",
    key: "eventType"
  },
  {
    name: "Impact",
    key: "impact"
  },
  {
    name: "Event Status",
    key: "eventStatus"
  },
  {
    name: "Customer",
    key: "customer"
  },
  {
    name: "Areas Affected",
    key: "areasAffected"
  },
  {
    name: "Actions Taken",
    key: "actionsTaken"
  },
  {
    name: "Outcome",
    key: "outCome"
  },
  {
    name: "Area Manager",
    key: "areaManager"
  },
  {
    name: "Responder",
    key: "responder"
  },
  {
    name: "Systems Affected",
    key: "systemsAffected"
  }

];

class AddUpdateIncident extends React.Component {
  constructor(props) {
    super(props);
    const userName = GetUserName();

    const canEditDcopEvent = IsSectionVisible(
      SECTIONS.SECURITY_INCIDENT,
      SECTIONS.SECURITY_INCIDENT_CREATE,
      SECTIONS.ADD_EDIT
    );

    const canEditDcopEventFullAccess = IsSectionVisible(
      SECTIONS.SECURITY_INCIDENT,
      SECTIONS.SECURITY_INCIDENT_CREATE,
      SECTIONS.FULL_ACCESS
    );

    this.state = {
      getToolTip: props.toolTip != null ? props.toolTip : [],
      loginUserMail: GetUserConfiguration().email,
      incidentCode: "",
      incidentId: props.incidentId ? props.incidentId : 0,
      propertyId: props.propertyId ? props.propertyId : 0,
      reportedBy: userName,
      textDescription: "",
      textIncidentNotes: "",
      incidentNotesHistory: "",
      textActionTaken: "",
      incidentDate: null,
      incidentStatusId: 0,
      incidentStatus: "",
      createdDate: null,
      subCategoryMasterDataIds: "",
      categoryMasterData: (props.categoryMasterData || []).filter(
        x => x.isDCOP === 1 && x.isActive === 1
      ),
      originalSubCategoryMasterData: (props.subCategoryMasterData || []).filter(
        x => x.isDCOP === 1 && x.isActive === 1
      ),
      subCategoryMasterData: (props.subCategoryMasterData || []).filter(
        x => x.isDCOP === 1 && x.isActive === 1
      ),
      dataCenterMasterData: props.incidentId > 0 ? props.dataCenterMasterData || [] : GetEnableProperty((props.dataCenterMasterData || [] || []), SECTIONS.SECURITY_INCIDENT_CREATE, "DataCenterId" ) ,
      categoryType: "",
      dataCenter: "",
      isIncidentAlreadyCreated: false,
      hasAttachment: false,
      openDialog: false,
      sourceSystem: "DCOP",
      sourceSystemId: DCOP_SOURCE_SYSTEM,
      isSharePointUserDisabled: false,
      isDcopUser: true,
      isOpen: false,
      securityObservationData: null,
      isEmailLogOpen: false,
      statusMasterData: (props.statusMasterData || []).filter(x=> 
       x.isActive === 1
      ),
      incidentStatusModifiedDate: null,
      emailLogs: [],
      statusId: "",
      oldIncidentStatusId: 0,
      canEditDcopEvent:canEditDcopEvent,
      IsSharePointEvent:false,
      canEditDcopEventFullAccess
    };
  }

  /**
   * call api when click on edit icon
   */
  componentDidMount() {
    window.scrollTo(0, 0);
    const { incidentId, propertyId } = this.state;
    incidentId &&
      incidentId > 0 &&
      this.getEditIncidentData(incidentId, propertyId);
    uploadFileList = [];
  }

/**
   * update component with state and props
   * @param {*} prevProps
   * @param {*} prevState
   */
   componentDidUpdate(prevProps) {
    window.scrollTo(0, 0);
    const props = this.props;
    if (
      props.incidentId != prevProps.incidentId ||
      props.message !== prevProps.message ||
      props.createdOn !== prevProps.createdOn
    ) {
      props.incidentId &&
        props.incidentId > 0 &&
        this.getEditIncidentData(
          props.incidentId,
          props.propertyId          
        );
      uploadFileList = [];
    }
  }

  /**
   * // set the state value after api call is done
   * @param {*} response
   * @returns
   */
  mapIncidentData = (response, emailLogs) => {
    if (!response.data) return;
    const { loginUserMail, incidentId } = this.state;
    const { categoryMasterData, subCategoryMasterData, statusMasterData, dataCenterMasterData } = this.props;
    const createdByUserEmail = response.data?.createdBy;

    const propertyId = response.data?.propertyId;

    const disabledProperty = GetPropertyVisibility(SECTIONS.SECURITY_INCIDENT_CREATE);
    const notSelectedDisabledProperty = disabledProperty.filter(x=> x !== propertyId);
    const dataCenterList = dataCenterMasterData.filter(dc => (notSelectedDisabledProperty || []).find(x=> x === dc.DataCenterId) === undefined);
    

    const disabledForUser = loginUserMail !== createdByUserEmail;

    const isSharePointUserDisabled =
      response.data.sourceSystemId === SHAREPOINT_SOURCE_SYSTEM &&
      IsSectionVisible(
        SECTIONS.SECURITY_INCIDENT,
        SECTIONS.SECURITY_EVENT_NOTIFICATION,
        SECTIONS.ADD_EDIT
      );

      const canEditSharePointEvent =
      response.data.sourceSystemId === SHAREPOINT_SOURCE_SYSTEM &&
      IsSectionVisible(
        SECTIONS.SECURITY_INCIDENT,
        SECTIONS.SECURITY_EVENT_NOTIFICATION,
        SECTIONS.ADD_EDIT
      );

      const canEditSharePointEventFullAccess =
      response.data.sourceSystemId === SHAREPOINT_SOURCE_SYSTEM &&
      IsSectionVisible(
        SECTIONS.SECURITY_INCIDENT,
        SECTIONS.SECURITY_EVENT_NOTIFICATION,
        SECTIONS.FULL_ACCESS
      );

      const IsSharePointEvent =
      response.data.sourceSystemId === SHAREPOINT_SOURCE_SYSTEM ;
    
    const superUser = IsSectionVisible(
      SECTIONS.SECURITY_INCIDENT,
      SECTIONS.SECURITY_INCIDENT_CREATE,
      SECTIONS.ADD_EDIT
    );

    const canEditDcopEvent = IsSectionVisible(
      SECTIONS.SECURITY_INCIDENT,
      SECTIONS.SECURITY_INCIDENT_CREATE,
      SECTIONS.ADD_EDIT
    );

    const canEditDcopEventFullAccess = IsSectionVisible(
      SECTIONS.SECURITY_INCIDENT,
      SECTIONS.SECURITY_INCIDENT_CREATE,
      SECTIONS.FULL_ACCESS
    );

    
    const subCategoryMasterDataIds = response.data?.subCategoryId;
    const categoryType = response.data?.categoryId;

    // datacenter
    const dataCenterName = dataCenterList.find(
      x => x.DataCenterId === propertyId
    )?.DataCenter || "";

    // filter activated/deactivated category according to field edible or not 
    const isCategoryDisabled = (!(incidentId>0) || (!(response.data.incidentStatusId > 1) && !disabledForUser)) ||
    (!(response.data.incidentStatusId > 1) && ((canEditDcopEvent==true && IsSharePointEvent==false)||
    (IsSharePointEvent==true && canEditSharePointEvent==true))|| 
    (canEditSharePointEventFullAccess==true && IsSharePointEvent==true) || 
    (canEditDcopEventFullAccess==true && IsSharePointEvent==false))
    ? false
    :  true

    const filteredCategoryMasterData = categoryMasterData.filter(
      x =>
        ((response?.data?.sourceSystemId === DCOP_SOURCE_SYSTEM &&
          x.isDCOP === 1 && x.isActive == 1) || (isCategoryDisabled === true && response?.data?.sourceSystemId === DCOP_SOURCE_SYSTEM &&
            x.isDCOP === 1 && x.isActive == 2  && x.categoryTypeId === categoryType)) ||
        (response?.data?.sourceSystemId === SHAREPOINT_SOURCE_SYSTEM &&
          x.isSharePoint === 1)
    );

    // category
    const categoryName = filteredCategoryMasterData.find(
      x => x.categoryTypeId == categoryType
    )?.categoryType || "";


    // filter activated/deactivated sub category according to field edible or not 
    const isSubCategoryDisabled = ((canEditDcopEvent==true && IsSharePointEvent==false)||(IsSharePointEvent==true && canEditSharePointEvent==true))
                    ? false
                    :  true
    // filter subcategory master data according to category id
    let subCategoryMasterData1 = subCategoryMasterData.filter(
      x =>
          x.CategoryId === categoryType && (((response?.data?.sourceSystemId === DCOP_SOURCE_SYSTEM &&
          x.isDCOP === 1 && x.isActive == 1) || (isSubCategoryDisabled === true && response?.data?.sourceSystemId === DCOP_SOURCE_SYSTEM &&
            x.isDCOP === 1 && x.isActive == 2 && x.SubCategoryId?.toString() === subCategoryMasterDataIds)) ||
        (response?.data?.sourceSystemId === SHAREPOINT_SOURCE_SYSTEM &&
          x.isSharePoint === 1))
    ) || []
    if (subCategoryMasterData1?.length <= 0) {
      subCategoryMasterData1 = subCategoryMasterData.filter(x=> x.CategoryId === null && 
        ((response?.data?.sourceSystemId === DCOP_SOURCE_SYSTEM &&
          x.isDCOP === 1 && x.isActive == 1)  || (isSubCategoryDisabled === true && response?.data?.sourceSystemId === DCOP_SOURCE_SYSTEM &&
            x.isDCOP === 1 && x.isActive == 2 && x.SubCategoryId?.toString() === subCategoryMasterDataIds) ||
        (response?.data?.sourceSystemId === SHAREPOINT_SOURCE_SYSTEM &&
          x.isSharePoint === 1)));
    }

    // subcategory
    const subCategoryDataId = subCategoryMasterData1.find(
      y => y.SubCategoryId == subCategoryMasterDataIds
    )?.SubCategory;
    
    // filter activated/deactivated status according to field edible or not 

    const isStatusDisabled =((canEditDcopEvent==true && IsSharePointEvent==false))
                    ? false
                    :  true

    // status master data
    const filteredStatusMasterData = statusMasterData.filter(x => (x.isActive === 1 || (isStatusDisabled === true && x.isActive === 2 && x.IncidentStatusId === response.data.incidentStatusId)))

    const statusId =  filteredStatusMasterData.find(
      y => y.IncidentStatusId == response.data.incidentStatusId
    )?.IncidentStatus;

    const incidentStatsId =  filteredStatusMasterData.find(
      y => y.IncidentStatusId == response.data.incidentStatusId
    )?.IncidentStatusId;

    this.setState({
      dataCenterMasterData: dataCenterList,
      hasAttachment: response.data.attachment,
      incidentId: response.data.incidentId,
      incidentCode: response.data.incidentCode,
      incidentStatusId: incidentStatsId,
      incidentStatus: response.data.incidentStatus,
      textDescription: response.data.incidentDescription || "",
      subCategoryMasterDataIds: subCategoryDataId,
      dataCenter: dataCenterName,
      categoryType: categoryName,
      incidentDate: moment(response.data?.incidentDate).format(
        "YYYY-MM-DDTHH:mm:ss"
      ),
      incidentNotesHistory:
        response?.data?.incidentResponseHistory?.split("\\n") || [],
      textIncidentNotes: response?.data?.incidentNotes,
      textActionTaken: response?.data?.actionTaken,
      disabledForUser,
      isIncidentAlreadyCreated:
        response.data.incidentStatusId > INCIDENT_STATUS.DRAFT,
      createdDate: response.data.createdDate,
      reportedBy: response.data.reportedBy,
      sourceSystem: response?.data?.sourceSystem,
      isDcopUser: response?.data?.sourceSystemId === DCOP_SOURCE_SYSTEM,
      isSharePointUserDisabled,
      sourceSystemId: response?.data?.sourceSystemId,
      superUser,
      securityObservationData: response?.data,
      categoryMasterData: filteredCategoryMasterData,
      subCategoryMasterData: subCategoryMasterData1,
      incidentStatusModifiedDate: response.data.incidentStatusModifiedDate_UTC,
      emailLogs: emailLogs.data || [],
      statusId,
      oldIncidentStatusId: response.data.incidentStatusId,
      statusMasterData: filteredStatusMasterData,
      canEditDcopEvent:canEditDcopEvent,
      canEditSharePointEvent:canEditSharePointEvent,
      IsSharePointEvent:IsSharePointEvent,
      canEditSharePointEventFullAccess:canEditSharePointEventFullAccess||false,
      canEditDcopEventFullAccess
    });
  };

  /**
   * get security incident data
   * @param {*} incidentId
   * @param {*} propertyId
   */
  getEditIncidentData = (incidentId, propertyId) => {
    apiBatchRequest([
      {
        url: API_URL.securityIncident.getSecurityIncidentById,
        params: {
          incidentId: incidentId,
          DateOffSet: moment().utcOffset(),
          propertyId
        },
        key: "incidentDetails"
      },
      {
        url: API_URL.securityIncident.GetEmailLog,
        params: {
          incidentId: incidentId,
          DateOffSet: moment().utcOffset(),
          propertyId
        },
        key: "emailLogs"
      }
    ]).then(({ incidentDetails, emailLogs }) => {
      this.mapIncidentData(incidentDetails, emailLogs);
    });
  };

  /**
   * set the state value by name
   * @param {*} key
   * @param {*} value
   */
  changeState = (key, value, isCascading, childKey) => {
    if (isCascading) {
      const { categoryMasterData, originalSubCategoryMasterData, sourceSystemId } = this.state;
      const categoryId = categoryMasterData.find(x=> x.categoryType === value)?.categoryTypeId;
      const newOriginalSubCategoryMasterData = [...originalSubCategoryMasterData];
      let subCategoryMasterData = newOriginalSubCategoryMasterData.filter(x=> x.CategoryId === categoryId && 
        ((sourceSystemId === DCOP_SOURCE_SYSTEM &&
          x.isDCOP === 1) ||
        (sourceSystemId === SHAREPOINT_SOURCE_SYSTEM &&
          x.isSharePoint === 1))) || [];
      if (subCategoryMasterData?.length <= 0) {
        subCategoryMasterData = newOriginalSubCategoryMasterData.filter(x=> x.CategoryId === null && 
          ((sourceSystemId === DCOP_SOURCE_SYSTEM &&
            x.isDCOP === 1) ||
          (sourceSystemId === SHAREPOINT_SOURCE_SYSTEM &&
            x.isSharePoint === 1)));
      }
      this.setState({
        [key]: value,
        [childKey]: "",
        subCategoryMasterData
      });
    } else {
      this.setState({
        [key]: value
      });
    }
    
  };

  /**
   * call this method on Save As Draft and Submit
   * @param {*} isRequestSubmitted
   * @returns
   */
  handleSave = isRequestSubmitted => {
    const {
      reportedBy,
      textDescription,
      textActionTaken,
      textIncidentNotes,
      dataCenter,
      categoryType,
      isIncidentAlreadyCreated,
      incidentDate,
      subCategoryMasterDataIds,
      categoryMasterData,
      dataCenterMasterData,
      subCategoryMasterData,
      loginUserMail,
      incidentId,
      hasAttachment,
      sourceSystemId,
      statusId,
      statusMasterData,
      oldIncidentStatusId,
      canEditSharePointEventFullAccess,
      superUser
    } = this.state;
    const currentDate = new Date(moment()).getTime();
    const observedDate = new Date(moment(incidentDate)).getTime();

    if (incidentDate != undefined && incidentDate != null) {
      const result2 = Operators.LessThanEqualsTo(observedDate, currentDate);

      if (!result2.result) {
        ShowToast(
          "Incident Date and Time should not be greater than today's date.",
          toastType.ERROR,
          5000,
          200
        );
        return;
      }
    }

    const selectedStatusId =  statusMasterData.find(
      y => y.IncidentStatus === statusId
    )?.IncidentStatusId || 0;

    const incidentStatusId = (isRequestSubmitted && incidentId <= 0)
      ? INCIDENT_STATUS.CREATED
      : (!isRequestSubmitted && incidentId <= 0)
      ? INCIDENT_STATUS.DRAFT
      : isRequestSubmitted && incidentId > 0
      ? selectedStatusId > 1 ? selectedStatusId 
      : (isRequestSubmitted && incidentId > 0 && oldIncidentStatusId === INCIDENT_STATUS.DRAFT) 
        ? INCIDENT_STATUS.CREATED : 0
      : INCIDENT_STATUS.DRAFT;

  
    const selectedDataCenterId = dataCenterMasterData.find(
      x => x.DataCenter === dataCenter
    )?.DataCenterId || 0;
    const selectedCategoryId = categoryMasterData.find(
      x => x.categoryType === categoryType
    )?.categoryTypeId || 0;
    const selectedSubCategoryMasterDataId = subCategoryMasterData.find(
      y => y.SubCategory === subCategoryMasterDataIds
    )?.SubCategoryId || 0;


    const requestBody = {
      incidentId: incidentId || 0,
      emailId: loginUserMail,
      categoryId: selectedCategoryId,
      subCategoryId: selectedSubCategoryMasterDataId,
      reportedBy: reportedBy,
      propertyId: selectedDataCenterId,
      incidentDescription: textDescription.trim(),
      actionTaken: textActionTaken,
      incidentDate: moment(incidentDate)
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss"),
      incidentNotes: textIncidentNotes,
      incidentStatusId,
      isIncidentAlreadySubmitted: isIncidentAlreadyCreated,
      dateOffset: moment().utcOffset(),
      attachment: uploadFileList.length > 0 ? true : hasAttachment,
      sourceSystemId: sourceSystemId,
      oldIncidentStatusId: oldIncidentStatusId,
      IsUpdatedFromUI: canEditSharePointEventFullAccess || false
    };

    const requestValidation = [
      {
        valueKey: "incidentDate",
        type: "datetime",
        isRequired: true,
        fieldsName: "Incident Date and Time"
      },
      {
        valueKey: "propertyId",
        type: "text",
        isRequired: true,
        fieldsName: "Data Center"
      },
      {
        valueKey: "categoryId",
        type: "text",
        isRequired: true,
        fieldsName: "Category"
      },
      {
        valueKey: "subCategoryId",
        type: "text",
        isRequired: true,
        fieldsName: "Sub Category"
      },
      {
        valueKey: "incidentDescription",
        type: "text",
        isRequired: true,
        fieldsName: "Description"
      }
    ];
    incidentId &&
    oldIncidentStatusId != INCIDENT_STATUS.DRAFT && (isRequestSubmitted && incidentId > 0 && incidentStatusId !== INCIDENT_STATUS.DRAFT && incidentStatusId === 0) &&
      requestValidation.push({
        valueKey: "incidentStatusId",
        type: "text",
        isRequired: true,
        fieldsName: "Status"
      });

    ((incidentId &&
      oldIncidentStatusId != INCIDENT_STATUS.DRAFT &&  incidentStatusId > 0  && (incidentStatusId > INCIDENT_STATUS.DRAFT) && sourceSystemId === DCOP_SOURCE_SYSTEM) || (superUser && sourceSystemId === SHAREPOINT_SOURCE_SYSTEM)) &&
      requestValidation.push({
        valueKey: "incidentNotes",
        type: "text",
        isRequired: true,
        fieldsName: "Notes"
      });

    if (validateInput(requestBody, requestValidation)) {
      if (incidentId) {
        requestBody.isUpdate = true;
        this.updateIncidentApi(requestBody);
      } else {
        this.addIncidentApi(requestBody);
      }
    }
  };

  /**
   * Call method api for new record creation
   * @param {*} params
   */
  addIncidentApi = params => {
    const { hasAttachment } = this.state;
    const upload = this.validateFile();
    if (upload) {
      params.attachment = uploadFileList.length > 0 ? true : hasAttachment;
      apiPost({
        url: API_URL.securityIncident.CreateSecurityIncident,
        postBody: params
      }).then(({ data: response, success: success }) => {
        if (success) {
          ShowToast(
            "Incident added Successfully",
            toastType.SUCCESS,
            5000,
            200
          );
          if (params.attachment)
            this.createSPFolder(response.data.incidentCode);
          else this.props.onSave(true);
        } else {
          this.props.onSave(false);
          ShowToast(
            "Something went wrong, please try again.",
            toastType.ERROR,
            5000,
            200
          );
          return;
        }
      });
    }
  };

  /**
   * Call method api for existing record creation
   * @param {*} params
   */
  updateIncidentApi = params => {
    const { hasAttachment } = this.state;
    const upload = this.validateFile();
    if (upload) {
      params.attachment = uploadFileList.length > 0 ? true : hasAttachment;
      apiPut({
        url: API_URL.securityIncident.UpdateSecurityIncident,
        postBody: params
      }).then(({ data: response, success: success }) => {
        if (response == null || response?.data.Success == 0) {
          ShowToast(response.data.Message, toastType.ERROR, 5000, 200);
          return false;
        }
        if (success) {
          ShowToast(
            "Incident updated Successfully",
            toastType.SUCCESS,
            5000,
            200
          );
          if (uploadFileList.length > 0)
            this.createSPFolder(response.data.incidentCode);
          else this.props.onSave(true);
        } else {
          this.props.onSave(false);
        }
      });
    }
  };

  /**
   * call on Cancel button and update security incident list
   * @param {*} isRefresh
   */
  refreshIncident = isRefresh => {
    if (isRefresh) {
      this.props.refreshIncident();
    }
  };

  /**
   * create the share point folder if not exist and the upload the file to that folder
   * @param {*} rCode
   * @returns
   */
  createSPFolder = (rCode = "") => {
    this.setState({ openDialog: true });
    if (!rCode) return;
    if (getSPSTokenData()) {
      getSpsAPiRequest(getSharepointUrl("getInnerFolder", rCode)).then(
        () => {
       //   console.log(spsDataRes, "spsDataRes1");
            this.onFileUpload(rCode);
        }
      );
    } else {
      apiRequest({
        url: API_URL.getSPSToken,
        params: { isHideLoader: true }
      }).then(({ data }) => {
        if (data) {
          setSPSToken(data);
        }
      });
    }
  };

  /**
   * validate the file if uploaded file is not correct format
   * @returns
   */

  validateFile = () => {
    let errorMessage = "";
    let isFileValid = true;
    const fileNames = [];
    uploadFileList.filter(item => {
      if (item.canUpload == false) {
        fileNames.push(item.fileData.name);
        errorMessage = commonLabels.fileMaxSize.message;
        isFileValid = false;
      }
      return item.canUpload;
    });
    if (isFileValid == false) {
      errorMessage;
      ShowToast(errorMessage + fileNames.join(","), toastType.ERROR, 5000);
    }
    return isFileValid;
  };

  /**
   * upload the file on onchange event
   * @param {*} rCode
   */
  onFileUpload = rCode => {
    let errorMessage = "";
    let isFileValid = true;
    const fileNames = [];
    const filesToUpload = uploadFileList.filter(item => {
      if (item.canUpload == false) {
        fileNames.push(item.fileData.name);
        errorMessage = commonLabels.fileMaxSize.message;
        isFileValid = false;
      }
      return item.canUpload;
    });
    if (isFileValid == false) {
      ShowToast(errorMessage + fileNames.join(","), toastType.ERROR, 5000);
    } else if (filesToUpload.length > 0) {
      this.setState({ hasAttachment: true });
      for (let index = 0; index < filesToUpload.length; index++) {
        spsApiPost({
          url: getSharepointUrl(
            "uploadFileSession",
            rCode,
            `${rCode}_${filesToUpload[index].fileData.name}`
          ),
          postBody: {
            fileSize: filesToUpload[index].fileData.size,
            item: {
              "@microsoft.graph.conflictBehavior": "replace"
            }
          }
        }).then(data => {
          if (data) {
            uploadSpsAPiRequest(
              data.data.uploadUrl,
              filesToUpload[index].fileData,
              true
            ).then(data => {
              if (data) {
                ShowToast("File uploaded successfully.", toastType.SUCCESS);
              } else {
                ShowToast("File not uploaded successfully.", toastType.ERROR);
              }
              this.props.onSave(true);
              this.setState({ openDialog: false });
            });
          }
        });
      }
    }
  };

  /**
   * set upload file list
   * @param {*} list
   */
  setUploadFilesList = list => {
    uploadFileList = list;
  };

  /**
   *
   * @param {*} value
   * @param {*} key
   */
  onChangeSwitchBtn = (value, key) => {
    this.setState({ [key]: value });
  };

  // call when click on close popup icon
  closePopup = () => {
    this.setState({
      isOpen: false
    });
  };

  /**
   * call on print the HSE record
   */
  handlePrint = () => {
    const { incidentId, propertyId } = this.state;
    const param =
      "IncidentId=" +
      incidentId +
      "&DateOffset=" +
      moment().utcOffset() +
      "&PropertyId=" +
      propertyId;
    printForm(
      `${PRINT_SECURITY_FORM}${param}`,
      "Blank form",
      "application/pdf",
      "Security"
    );
  };

  /**
   * open email log pop up
   * @param {*} isOpen 
   */
  handleClick = (isOpen) => {
    const { emailLogs } = this.state;
    const emailContent = 
      (<TableContainer component={Paper}>
       <Table className={"tenant-list-table popup-table"}>
          <TableHead>
              <TableRow className={"blue-custom-title"} > 
                  {EMAIL_LOG_CONFIG.map((col, index) => 
                  {return <TableCell key={index}> {col.name} </TableCell>} 
                  )}
              </TableRow>
          </TableHead>
          <TableBody>
            {emailLogs && emailLogs.map((logs, ind) => {
              return (<TableRow key={ind}>
                          {EMAIL_LOG_CONFIG.map((col, index) => 
                            {return (<TableCell key={index+ ind}> 
                                        { getFormattedValues(logs[col.key], col.format, true)} 
                                     </TableCell>)} 
                          )}
                      </TableRow>)
            })}
            {emailLogs?.length < 1 && <TableRow>
                                       <TableCell align={"Center"} colSpan={EMAIL_LOG_CONFIG?.length}>
                                          {"No data available\r"}
                                       </TableCell>
                                      </TableRow>}
          </TableBody>
       </Table>
      
       </TableContainer>)
    this.setState({
      isEmailLogOpen: isOpen,
      emailContent: emailContent
    })
  }


  render() {
    const {
      isOpen,
      incidentId,
      incidentCode,
      incidentStatusId,
      incidentStatus,
      reportedBy,
      categoryType,
      dataCenter,
      incidentDate,
      createdDate,
      subCategoryMasterDataIds,
      categoryMasterData,
      subCategoryMasterData,
      dataCenterMasterData,
      disabledForUser,
      textIncidentNotes,
      textDescription,
      hasAttachment,
      sourceSystem,
      isSharePointUserDisabled,
      isDcopUser,
      superUser,
      securityObservationData,
      getToolTip,
      incidentNotesHistory,
      openDialog,
      isEmailLogOpen,
      emailContent,
      statusMasterData,
      incidentStatusModifiedDate,
      statusId,
      sourceSystemId,
      canEditDcopEvent,
      canEditSharePointEvent,
      IsSharePointEvent,
      canEditSharePointEventFullAccess,
      oldIncidentStatusId,
      canEditDcopEventFullAccess
    } = this.state;

    const isFieldsEnabled = IsSectionVisible(
      SECTIONS.SECURITY_INCIDENT,
      SECTIONS.SECURITY_INCIDENT_CREATE,
      SECTIONS.ADD_EDIT
    );

    
    localStorage.setItem("IsInEditMode", 1);

    const createdDateTime = createdDate
      ? moment(createdDate).format("MM/DD/YYYY hh:mm A")
      : moment(new Date()).format("MM/DD/YYYY hh:mm A");

    return (
      <div className={"row addUpdateReqPage bottom-xs"}>
        <div className={"row col-xs-12 mb-3 incident-label"}>
          {incidentId > 0 && (
            <div className={"col-xs-2"}>
              <InputLabel
                disabled={!isFieldsEnabled}
                className={"small-label"}
                size={"small"}
                id={"incidentCode"}
              >
                {"Incident # : "}
                {incidentCode}
              </InputLabel>
            </div>
          )}
          {incidentId > 0 && (
            <div className={"col-xs-3"}>
              <InputLabel
                disabled={!isFieldsEnabled}
                className={"small-label"}
                size={"small"}
                id={"incidentStatus"}
              >
                {"Incident Status : "}
                {incidentStatus}  {incidentStatusModifiedDate !== null ? moment(incidentStatusModifiedDate).format("MM/DD/YYYY hh:mm A") : ""}
              </InputLabel>
            </div>
          )}
          <div className={"col-xs-3"}>
            <InputLabel
              disabled={!isFieldsEnabled}
              className={"small-label"}
              size={"small"}
              id={"createdOn"}
            >
              {"Opened On : "}
              {createdDateTime ? createdDateTime : null}
            </InputLabel>
          </div>
          <div className={"col-xs-3"}>
            <InputLabel
              disabled={!isFieldsEnabled}
              className={"small-label"}
              size={"small"}
              id={"sourceSystem"}
            >
              {"Source System : "}
              {sourceSystem ? sourceSystem : null}
            </InputLabel>
          </div>
            <div className={"col-xs-12 col-md-12 col-lg-12 end-xs"}>
            {incidentId > 0 && oldIncidentStatusId > 1 && sourceSystemId === DCOP_SOURCE_SYSTEM && isFieldsEnabled && (
              <Tooltip title={getToolTipText(getToolTip, TOOLTIP_LABEL.EMAIL_LOG)}>
                 <IconButton size={"small"} style={{ margin: "0px 4px" }}>
                     <DraftsIcon onClick={() => { this.handleClick(true) }} style={{ fontSize: "2rem" }} />
                 </IconButton>
              </Tooltip>
              )}
              {incidentId > 0 &&
                <Tooltip title={getToolTipText(getToolTip, TOOLTIP_LABEL.PRINT)}>
                <IconButton size={"small"} style={{ margin: "0px 4px" }}>
                  <PrintIcon
                    onClick={() => {
                      this.handlePrint();
                    }}
                    style={{ fontSize: "2rem" }}
                  />
                </IconButton>
                </Tooltip> }            
            </div>

        </div>
        <div className={"row col-xs-12 rowList step1-parent"}>
          <div className={"col-xs-12"} style={{ paddingRight: "1.5rem" }}>
            <div className={"row content"}>
              <div className={"col-xs-3"}>
                <TextFieldWithToolTip
                  isRequired={false}
                  labelHeading={"Reported By"}
                  value={reportedBy}
                  disabled
                  className={"box-style"}
                  toolTip={getToolTipText(
                    getToolTip,
                    TOOLTIP_LABEL.REPORTED_BY
                  )}
                />
              </div>
              <div className={"col-xs-3 content"}>
                <KeyBoardDateTimePickers
                  toolTip={getToolTipText(
                    getToolTip,
                    TOOLTIP_LABEL.INCIDENT_DATE_AND_TIME
                  )}
                  valueDate={incidentDate}
                  disabled={
                    (canEditDcopEvent==true && IsSharePointEvent==false) ||
                    (canEditSharePointEventFullAccess==true && IsSharePointEvent==true)
                      ? false
                      :  true
                  }
                  label={"Incident Date and Time"}
                  format={"MM/DD/YYYY hh:mm A"}
                  required
                  maxDate={moment().format("MM/DD/YYYY")}
                  handleChange={date => this.setState({ incidentDate: date })}
                />
              </div>

              <div className={"col-xs-3"}>
                <LabelWithSelect
                  className={"box-style"}
                  labelHeading={"Data Center"}
                  toolTip={getToolTipText(
                    getToolTip,
                    TOOLTIP_LABEL.DATA_CENTER
                  )}
                  optionsList={uniqBy(
                    convertIntoDDFormat(
                      dataCenterMasterData || [],
                      "DataCenter",
                      "DataCenter"
                    ),
                    x => x.id
                  )}
                  isRequired
                  selectedId={dataCenter}
                  keyValue={"dataCenter"}
                  onChange={this.changeState}
                  disabled={(!(incidentId>0) || (!(incidentStatusId > 1 || oldIncidentStatusId > 1) && !disabledForUser)) ||
                    (!(incidentStatusId > 1 || oldIncidentStatusId > 1) && ((canEditDcopEvent==true && IsSharePointEvent==false)||
                    (IsSharePointEvent==true && canEditSharePointEvent==true)))
                    ? false
                    :  true}
                  autofill={"autofill"}
                />
              </div>
              <div className={"col-xs-3"}>
                <LabelWithSelect
                  className={"box-style"}
                  labelHeading={"Category"}
                  id={"Category"}
                  openToolTipDialog
                  toolTip={getToolTipText(getToolTip, TOOLTIP_LABEL.CATEGORY)}
                  optionsList={uniqBy(
                    convertIntoDDFormat(
                      categoryMasterData || [],
                      "categoryType",
                      "categoryType"
                    ),
                    x => x.id
                  )}
                  isRequired
                  selectedId={categoryType}
                  keyValue={"categoryType"}
                  onChange={(key, value) =>
                    this.changeState(key, value, true, "subCategoryMasterDataIds")}
                  disabled={(!(incidentId>0) || (!(incidentStatusId > 1 || oldIncidentStatusId > 1) && !disabledForUser)) ||
                    (!(incidentStatusId > 1 || oldIncidentStatusId > 1) && ((canEditDcopEvent==true && IsSharePointEvent==false)||
                    (IsSharePointEvent==true && canEditSharePointEvent==true))|| 
                    (canEditSharePointEventFullAccess==true && IsSharePointEvent==true) || 
                    (canEditDcopEventFullAccess==true && IsSharePointEvent==false))
                    ? false
                    :  true}
                  autofill={"autofill"}
                />
              </div>
              <div className={"col-xs-3"}>
                <LabelWithSelect
                  className={"box-style"}
                  labelHeading={"Sub Category"}
                  id={"Sub Category"}
                  // width="120px"
                  optionsList={uniqBy(
                    convertIntoDDFormat(
                      subCategoryMasterData || [],
                      "SubCategory",
                      "SubCategory"
                    ),
                    x => x.id
                  )}
                  isRequired
                  toolTip={getToolTipText(
                    getToolTip,
                    TOOLTIP_LABEL.SUB_CATEGORY
                  )}
                  disabled={
                    ((canEditDcopEvent==true && IsSharePointEvent==false)||(IsSharePointEvent==true && canEditSharePointEvent==true))
                    ? false
                    :  true
                  }
                  selectedId={subCategoryMasterDataIds}
                  keyValue={"subCategoryMasterDataIds"}
                  onChange={this.changeState}
                  autofill={"autofill"}
                />
              </div>
              {oldIncidentStatusId  > 1 &&  <div className={"col-xs-3"}>
                <LabelWithSelect
                  className={"box-style"}
                  labelHeading={"Status"}
                  id={"Status"}
                  optionsList={uniqBy(
                    convertIntoDDFormat(
                      statusMasterData.filter(x=> x.IncidentStatusId !==1 ) || [],
                      "IncidentStatus",
                      "IncidentStatus"
                    ),
                    x => x.id
                  )}
                  isRequired
                  toolTip={getToolTipText(
                    getToolTip,
                    TOOLTIP_LABEL.INCIDENT_STATUS
                  )}
                  disabled={((canEditDcopEvent==true && IsSharePointEvent==false))
                    ? false
                    :  true}
                  selectedId={statusId}
                  keyValue={"statusId"}
                  onChange={this.changeState}
                  autofill={"autofill"}                  
                />
                                            </div>}
              {!isDcopUser && (
                <div className={"col-xs-3 content"}>
                  <div
                    className={"compContainer"}
                    style={{ marginTop: "43px" }}
                  >
                    <Link
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.setState({
                          isOpen: true
                        });
                      }}
                    >
                      {"Show More...\r"}
                    </Link>
                  </div>
                </div>
              )}
            </div>

            <div className={"row content rowList"}>
              <div className={"col-xs-12 no-padding content"}>
                <div className={"compContainer"}>
                  <InputLabelWithToolTip
                    className={"compLabel"}
                    id={"requestDescriptionLabel"}
                    disabled={(!(incidentId>0) || (!(incidentStatusId > 1 || oldIncidentStatusId > 1) && !disabledForUser)) ||
                      (!(incidentStatusId > 1 || oldIncidentStatusId > 1) && ((canEditDcopEvent==true && IsSharePointEvent==false)||
                      (IsSharePointEvent==true && canEditSharePointEvent==true))|| (canEditSharePointEventFullAccess==true && IsSharePointEvent==true))
                    ? false
                    :  true}
                    isRequired
                    labelHeading={"Description"}
                    toolTip={getToolTipText(
                      getToolTip,
                      TOOLTIP_LABEL.DESCRIPTION
                    )}
                  />

                  <TextareaAutosize
                    minRows={4}
                    maxRows={4}
                    aria-label={"Description"}
                    placeholder={"Description"}
                    value={textDescription}
                    onChange={e =>
                      this.changeState("textDescription", e.target.value)}
                    disabled={
                      (!(incidentId>0) || (!(incidentStatusId > 1 || oldIncidentStatusId > 1) && !disabledForUser)) ||
                      (!(incidentStatusId > 1 || oldIncidentStatusId > 1) && ((canEditDcopEvent==true && IsSharePointEvent==false)||
                      (IsSharePointEvent==true && canEditSharePointEvent==true)))
                      ? false
                      :  true
                    }
                  />
                </div>
              </div>
            </div>
            <div className={"row content rowList"}>
              <div className={"col-xs-12 no-padding content"}>
                <div className={"compContainer"}>
                  <InputLabelWithToolTip
                    className={"compLabel"}
                    id={"notesLabel"}
                    disabled={
                       ((canEditDcopEvent==true && IsSharePointEvent==false)||(IsSharePointEvent==true && canEditSharePointEvent==true))
                    ? false
                    :  true
                    }
                    isRequired={
                      incidentId && (incidentStatusId > INCIDENT_STATUS.DRAFT || oldIncidentStatusId > INCIDENT_STATUS.DRAFT)
                        ? true
                        : false
                    }
                    labelHeading={"Notes"}
                    toolTip={getToolTipText(getToolTip, TOOLTIP_LABEL.NOTES)}
                  />
                  <TextareaAutosize
                    disabled={
                      ((canEditDcopEvent==true && IsSharePointEvent==false)||(IsSharePointEvent==true && canEditSharePointEvent==true))
                    ? false
                    :  true
                    }
                    minRows={4}
                    maxRows={4}
                    className={"borderSize"}
                    aria-label={"IncidentNotes"}
                    placeholder={"Notes"}
                    value={textIncidentNotes}
                    onChange={e =>
                      this.changeState("textIncidentNotes", e.target.value)}
                  />
                  <div
                    className={
                      (superUser
                      ? true
                      : (isDcopUser && isFieldsEnabled == false) ||
                        (!isDcopUser && !isSharePointUserDisabled))
                        ? "response-disabled response-box-top-border"
                        : "response-box response-box-top-border"
                    }
                    disabled={
                      superUser
                        ? false
                        : (isDcopUser && !isFieldsEnabled) ||
                          (!isDcopUser && !isSharePointUserDisabled)
                    }
                  >
                    {incidentNotesHistory ? (
                      incidentNotesHistory.map(res => (
                        <>
                          <div
                            className={"response"}
                            disabled={
                              superUser
                                ? false
                                : (isDcopUser && !isFieldsEnabled) ||
                                  (!isDcopUser && !isSharePointUserDisabled)
                            }
                          >
                            {res.split("\\s")[0]}
                          </div>
                          <div
                            className={"response-small"}
                            disabled={
                              superUser
                                ? false
                                : (isDcopUser && !isFieldsEnabled) ||
                                  (!isDcopUser && !isSharePointUserDisabled)
                            }
                          >
                            {res.split("\\s")[1]}
                          </div>
                          <div>
                            {" "}
                            <br />{" "}
                          </div>
                        </>
                      ))
                    ) : (
                      <div className={"response"} />
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className={"row content rowList"}>
              <div className={"col-xs-12 no-padding"}>
                <div style={{ marginLeft: "12px" }}>
                  <FileAttachments
                    hasAttachment={hasAttachment}
                    requestCode={incidentCode}
                    setUploadFilesList={this.setUploadFilesList}
                    downloadPermission={
                      superUser
                        ? true
                        :  ((canEditDcopEvent==true && IsSharePointEvent==false)||(IsSharePointEvent==true && canEditSharePointEvent==true))
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={"col-xs-12 end-xs req_actions"}>
          <Button
            autoFocus
            onClick={() => this.props.refreshIncident(false)}
            variant={"contained"}
          >
            {"Cancel\r"}
          </Button>
          {
            <>
              {incidentStatusId <= 1 &&
                ((isDcopUser &&
                  IsSectionVisible(
                    SECTIONS.SECURITY_INCIDENT,
                    SECTIONS.SECURITY_INCIDENT_CREATE,
                    SECTIONS.ADD_EDIT
                  )) ||
                  (!isDcopUser && isSharePointUserDisabled)) && (
                  <>
                    <Button
                      autoFocus
                      onClick={() => this.handleSave(false)}
                      variant={"contained"}
                    >
                      {"Save As Draft\r"}
                    </Button>
                  </>
                )}
              {(((canEditDcopEvent==true && IsSharePointEvent==false)||(IsSharePointEvent==true && canEditSharePointEvent==true))
                      ) && (
                  <>
                    <Button
                      autoFocus
                      onClick={() => this.handleSave(true)}
                      variant={"contained"}
                    >
                      {"Submit\r"}
                    </Button>
                  </>
              )}
             
            </>
          }
        </div>
        {openDialog && (
          <Dialog
            style={{ marginTop: "60px" }}
            open={openDialog}
            aria-labelledby={"responsive-dialog-title"}
            maxWidth={"lg"}
          >
            <div style={{ padding: "4px 13px", fontSize: "larger" }}>
              {"Uploading file...\r"}
            </div>
          </Dialog>
        )}
        {isOpen && (
          <Dialog
            id={"event-notification-details"}
            maxWidth={"md"}
            open={isOpen}
            disableBackdropClick
            onClose={() => this.closePopup()}
            PaperComponent={PaperComponent}
            aria-labelledby={"responsive-dialog-title"}
          >
            <AppBar
              style={{ position: "relative", backgroundColor: "#064473" }}
            >
              <Toolbar>
                <Typography variant={"h6"} style={{ flex: "1" }}>
                  <DialogTitle
                    style={{ cursor: "move" }}
                    id={"responsive-dialog-title"}
                    className={"common-color white-label"}
                  >
                    {"Event Notification Details\r"}
                  </DialogTitle>
                </Typography>
                <Tooltip title={"Close"}>
                  <IconButton
                    edge={"end"}
                    color={"inherit"}
                    onClick={() => {
                      this.closePopup();
                    }}
                    aria-label={"close"}
                    className={"white-button"}
                  >
                    <IoMdCloseCircleOutline />
                  </IconButton>
                </Tooltip>
              </Toolbar>
            </AppBar>
            <DialogContent>
              <DialogContentText>
                <Table>
                  <TableBody>
                    {securityEventNotification.map((col, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell key={index + col.name}>
                            <b>{col.name}</b>
                          </TableCell>
                          <TableCell key={index + col.key}>
                            {securityObservationData[col.key] !== undefined &&
                            securityObservationData[col.key] !== null &&
                            securityObservationData[col.key] !== "" ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: securityObservationData[col.key]
                                }}
                              />
                            ) : (
                              "-"
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </DialogContentText>
            </DialogContent>
          </Dialog>
        )}
        <DialogModal
          open={isEmailLogOpen}
          className={"reply-child-content"}
          title={EMAIL_LOG_HEADER}
          children={emailContent}
          onClose={() => { this.setState({ isEmailLogOpen: false }) }}
        />
      </div>
    );
  }
}
export default AddUpdateIncident;
